import gql from 'graphql-tag';
import { Query, Mutation } from 'core/index';
import { USER_ERROR_FIELDS } from 'core/errors';

const SPACE_SUBSCRIPTION_STATUS = gql`
  fragment spaceSubscriptionStatus on Space {
    id
    whichTypes
    trialPeriodEnd
    hasPaidSubscription
    hasPrivateProjectsSubscription
    hasBillingPermissions
    remainingSharedFiles
    spaceType
    content {
      id
      slug
    }
  }
`;

export const LOCAL_PROFILE_FIELDS = gql`
  ${SPACE_SUBSCRIPTION_STATUS}
  fragment localProfileFields on Profile {
    id
    user {
      id
      username
    }
    profileConfirmed
    bio
    username
    invitesLeft
    locale
    fullName
    intent {
      id
      name
    }
    userType {
      id
      name
    }
    avatar {
      id
      path
      url
    }
    imageFallbackChar
    preferredName
    inSpace {
      ...spaceSubscriptionStatus
    }
    content {
      id
      slug
      whitelabel
    }
  }
`;

export const SIGN_IN_MUTATION = gql`
  ${USER_ERROR_FIELDS}
  ${LOCAL_PROFILE_FIELDS}
  mutation Login($signInInput: SignInInput) {
    signInResult(signInData: $signInInput)
      @connection(key: "signInResult", filter: [""]) {
      result
      profile {
        ...localProfileFields
      }
      token
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class SignInMutation extends Mutation {
  static conf = {
    GQL: SIGN_IN_MUTATION,
    inputName: 'signInInput',
    resultPath: 'signInResult',
    errorPath: 'signInResult.userErrors',
  };
}

export const WHOAMI = gql`
  ${LOCAL_PROFILE_FIELDS}
  query WhoAmI {
    loggedInUser {
      id
      profile {
        ...localProfileFields
        user {
          email
        }
      }
      isStaff
      flagsJSON: flags
    }
  }
`;

export class WhoAmIQuery extends Query {
  static conf = {
    GQL: WHOAMI,
    resultPath: 'loggedInUser',
  };
}

const REQUEST_RESET_PASSWORD_MUTATION = gql`
  ${USER_ERROR_FIELDS}
  mutation RequestResetPassword($usernameOrEmail: String) {
    requestResetPassword(usernameOrEmail: $usernameOrEmail) {
      result
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class RequestResetPasswordMutation extends Mutation {
  static conf = {
    GQL: REQUEST_RESET_PASSWORD_MUTATION,
    inputName: 'usernameOrEmail',
    resultPath: 'requestResetPassword',
    errorPath: 'requestResetPassword.userErrors',
  };
}

const NEW_PASSWORD_MUTATION = gql`
  ${USER_ERROR_FIELDS}
  mutation NewPassword($newPasswordInput: NewPasswordInput) {
    newPassword(newPasswordInput: $newPasswordInput)
      @connection(key: "newPassword", filter: [""]) {
      result
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class NewPassWordMutation extends Mutation {
  static conf = {
    GQL: NEW_PASSWORD_MUTATION,
    inputName: 'newPasswordInput',
    resultPath: 'newPassword',
    errorPath: 'newPassword.userErrors',
  };
}
